import { render, staticRenderFns } from "./AddEditGroupDialog.vue?vue&type=template&id=11d0fa58&scoped=true"
import script from "./AddEditGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddEditGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0fa58",
  null
  
)

export default component.exports